// extracted by mini-css-extract-plugin
export var bulkPurchaseTable = "_d-0";